// @flow
import client from '../../client'
import format from '../../utils/format'

// Constants
export const GET_TC_CLIENT_DATA_ENDPOINT =
  '/corporate/gbt/payloads/{0}/tc_client/'

/**
 * Get TC's client data
 * @param {string} PNR the passenger name record for gbt
 * @return {Promise|Error} A resolved Promise with the client data or Rejected with an Error
 */
export const getTCClientData = (data: { pnr: string }): Promise<any> => {
  const endpoint = format(GET_TC_CLIENT_DATA_ENDPOINT, data.pnr)
  return client.get(endpoint)
}

export default getTCClientData
